import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ordernarPorNombre' // nombre del pipe en las directivas
})

export class OrdenarPorNombrePipe implements PipeTransform {

    constructor(){}

    /*
    Recibe un arreglo que despues es devuelto ordenado por los apellidos del personal
    */
    transform(arregloPersonal:any):any{
        //Verifica que el arreglo no sea algo nullo
        if(arregloPersonal != null){
            arregloPersonal.sort((a: any, b: any) => {
                if(a.informacionPersonal.apellidoPaterno < b.informacionPersonal.apellidoPaterno) return -1;
                if(a.informacionPersonal.apellidoPaterno > b.informacionPersonal.apellidoPaterno) return 1;
                });
                return arregloPersonal;
        }
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/ordenar-por-nombre.pipe.ts